import { render, staticRenderFns } from "./ResetLoginAttempts.vue?vue&type=template&id=06fa5962&scoped=true"
import script from "./ResetLoginAttempts.vue?vue&type=script&lang=js"
export * from "./ResetLoginAttempts.vue?vue&type=script&lang=js"
import style0 from "./ResetLoginAttempts.vue?vue&type=style&index=0&id=06fa5962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa5962",
  null
  
)

export default component.exports